export default __webpack_public_path__ + "static/media/logotipo-ifeira.b563cc5f.svg";